import { Flex } from "antd";
import { observer } from "mobx-react-lite";
import { Role } from "parse";
import React, { useEffect } from "react";
import { useProject } from "..";
import { RoleTag, UserTag } from "../../../../_shared";
import { _Role, _User } from "../../../../js/parsegenerated";

export const ProjectAssignment = observer(() => {
  const { project } = useProject();
  const [roles, setRoles] = React.useState<Role[]>([]);
  const [users, setUsers] = React.useState<Parse.User[]>([]);

  useEffect(() => {
    if (!project) return;
    project.get("assignedRoles").query().find().then(setRoles);
    project.get("assignedUsers").query().find().then(setUsers);
  }, [project]);

  return (
    <Flex gap="small" wrap="wrap" justify="center">
      {users.map((user) => (
        <UserTag key={user.id} user={user as _User} />
      ))}
      {roles.map((role) => (
        <RoleTag key={role.id} role={role as _Role} />
      ))}
    </Flex>
  );
});
